export const administrationSites = [{ name: "Outpatient" }, { name: "Clinic" }, { name: "Self" }];

export const BRANDED_TERM_TYPES = {
  BN: "BN",
  SBDF: "SBDF",
  SBDC: "SBDC",
  SBD: "SBD",
  BPCK: "BPCK"
};

export const NOT_BRANDED_TERM_TYPES = {
  PIN: "PIN",
  SCDF: "SCDF",
  SCDC: "SCDC",
  SCD: "SCD",
  GPCK: "GPCK"
};

export const PACK_TERM_TYPES = {
  BPCK: "BPCK",
  GPCK: "GPCK"
};

export const TERM_TYPES = {
  ...NOT_BRANDED_TERM_TYPES,
  ...BRANDED_TERM_TYPES
};
